import { Modal } from "@smart/itops-sb-design-system-dom";
import { useDeleteForm } from "@smart/manage-gql-client-dom";

import { GqlForm } from "../types";

export type DeletingFormModalProps = {
  deletingForm: GqlForm | undefined;
  onClose: () => void;
};

export const DeletingFormModal = ({
  deletingForm,
  onClose,
}: DeletingFormModalProps) => {
  const [deleteForm, { loading }] = useDeleteForm();

  return (
    <Modal
      onClose={onClose}
      open={!!deletingForm}
      loading={loading}
      header={{
        icon: "solidTrashCan",
        text: "Delete form",
      }}
      footer={{
        buttons: [
          {
            text: "Cancel",
            variant: "secondarySubtle",
            onClick: onClose,
          },
          {
            text: "Yes, delete",
            variant: "primaryDefault",
            onClick: async () => {
              if (deletingForm)
                await deleteForm({ variables: { uri: deletingForm.uri } });
              onClose();
            },
          },
        ],
      }}
    >
      <p>
        Are you sure you want to delete &quot;
        {deletingForm?.formTitle || "this form"}&quot;?
      </p>
    </Modal>
  );
};
